<template>
  <div class="row">
    <div class="col-md-6">
      <div class="dash-inner-box">
        <div class="admission-form cutOff-form">
        <form id="cutOffForm">
          <div class="dashboard-heading">
            <h1 class="form-heading mb-0">{{eCutoff ? 'Update' : 'Add New'}} Cut Off</h1>
          </div>
          <div class="row p10-20">
            <div class="col-md-12 mb-15">
              <select id="cutOffCourse" name="course_id" data-type="isRequired" placeholder="Select Course"
                      v-bind:value="eCutoff ? eCutoff.assgined_course_enc_id : ''"
                      @blur="$parent.validateFiled($event)" class="formTextFields saveField">
                <option value="">Select Course</option>
                <option v-for="cutOffAc in $parent.addmissionCourses" v-bind:value="cutOffAc.assigned_college_enc_id">
                  {{ cutOffAc.course_name }}
                </option>
              </select>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>General</label>
              <input type="text" id="cutOffGenral" name="general" data-type="floatNum"
                     placeholder="General" v-bind:value="eCutoff ? eCutoff.general : ''"
                     @blur="$parent.validateFiled($event)" data-id="reqAlso" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>OBC</label>
              <input type="text" id="cutOffOBC" name="obc" data-type="floatNum"
                     placeholder="Other Backward Class" v-bind:value="eCutoff ? eCutoff.obc : ''"
                     @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>SC</label>
              <input type="text" id="cutOffSC" name="sc" data-type="floatNum"
                     v-bind:value="eCutoff ? eCutoff.sc : ''" placeholder="Scheduled Castes"
                     @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>ST</label>
              <input type="text" id="cutOffST" name="st" data-type="floatNum"
                     placeholder="Scheduled Tribes" v-bind:value="eCutoff ? eCutoff.st : ''"
                     @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>PWD</label>
              <input type="text" id="cutOffPWD" name="pwd" data-type="floatNum"
                     placeholder="Persons With Disabilities" v-bind:value="eCutoff ? eCutoff.pwd : ''"
                     @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-6 col-sm-6 mb-15">
              <label>EWS</label>
              <input type="text" id="cutOffEWS" name="ews" data-type="floatNum"
                     placeholder="Economically Weaker Section" v-bind:value="eCutoff ? eCutoff.ews : ''"
                     @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12 co-flex">
              <label>Cut Off In</label>
              <select name="mode" value="0" data-type="isRequired" v-bind:value="eCutoff ? eCutoff.mode : 0"
                      class="formTextFields saveField">
                <option value="0">Percentage</option>
                <option value="1">Percentile</option>
              </select>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12 text-center">
              <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'cutOffForm'">
                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
              </button>
              <button type="button" class="cpe-button" v-else @click="saveCutOffData()">{{eCutoff ? 'Update' : 'Add'}}</button>
              <button type="button" class="cpe-button cp_cancelBtn" data-type="button" v-show="eCutoff" data-id="cutoff"
                      @click="$parent.cancelUpdate()" >Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1 class="">Existing Cut Offs</h1>
        </div>
        <!--Accordion wrapper-->
        <div class="accordion md-accordion p10-20" id="accordionCutoff" role="tablist" aria-multiselectable="true">
          <!-- Accordion card -->
          <div class="card" v-for="cutoff in cutoffList">
            <!-- Card header -->
            <div class="card-header" role="tab" v-bind:id="`co${cutoff.college_cut_off_enc_id}`">
              <a class="collapsed" data-toggle="collapse" data-parent="#accordionCutoff"
                 v-bind:href="`#${cutoff.college_cut_off_enc_id}`"
                 aria-expanded="false" v-bind:aria-controls="cutoff.college_cut_off_enc_id">
                <h5 class="mb-0 mt-0">
                  {{ cutoff.course_name }} <i class="fas fa-angle-down rotate-icon"></i>
                </h5>
              </a>
            </div>

            <!-- Card body -->
            <div v-bind:id="cutoff.college_cut_off_enc_id" class="collapse" role="tabpanel"
                 v-bind:aria-labelledby="`co${cutoff.college_cut_off_enc_id}`"
                 data-parent="#accordionCutoff">
              <div class="cutoff card-body">
                <ul class="cutOff-list">
                  <li>General: <span>{{ cutoff.general ? cutoff.general : 'NA' }}</span></li>
                  <li>OBC: <span>{{ cutoff.obc ? cutoff.obc : 'NA' }}</span></li>
                  <li>SC: <span>{{ cutoff.sc ? cutoff.sc : 'NA' }}</span></li>
                  <li>ST: <span>{{ cutoff.st ? cutoff.st : 'NA' }}</span></li>
                  <li>PWD: <span>{{ cutoff.pwd ? cutoff.pwd : 'NA' }}</span></li>
                  <li>EWS: <span>{{ cutoff.ews ? cutoff.ews : 'NA' }}</span></li>
                  <li>Cut off In: <span>{{ cutoff.mode == 0 ? 'Percentage' : 'Percentile' }}</span></li>
                </ul>
                <div class="actionBtns">
                  <button class="removeSch editBtn" v-bind:data-id="cutoff.college_cut_off_enc_id" @click="editCutoff()">
                    Edit
                  </button>
                  <button class="removeSch" v-bind:data-id="cutoff.college_cut_off_enc_id" @click="removeCutoff()">
                    Delete
                  </button>
                </div>
              </div>
            </div>

          </div>
          <!-- Accordion card -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {

  data(){
    return{
      cutoffList: [],
      eCutoff : null,
    }
  },
  mounted() {
    this.getCutOff();
  },
  methods: {
    saveCutOffData() {
      let cutOffForm = document.querySelector('#cutOffForm');
      let data = this.$parent.createDataObject(cutOffForm);
      let hasError = cutOffForm.querySelector('.hasError');
      if (hasError) {
        return false;
      }
      let self = this;
      self.$parent.notchLoading = 'cutOffForm';
      axios.post(`${this.$parent.url}api/v2/college-profile/save-cutoff`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              self.$parent.emptyFormFields(cutOffForm);
              self.getCutOff();
              if(self.eCutoff){
                self.eCutoff = '';
              }
              self.$parent.notchLoading = null;
            } else {
              toastr.error('Some error occurred. Try again later', 'Oops!!');
            }
          }
      )
    },
    getCutOff() {
      let t = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/cutoff-list`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.cutoffList = response['data']['response']['cutoff'];
            }
          }
      )
    },
    removeCutoff(){
      let cutoff_id =  event.currentTarget.getAttribute('data-id');
      let data = {'cutoff_id': cutoff_id};
      let self = this;
      axios.post(`${this.$paren.url}api/v2/college-profile/remove-cutoff`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.getCutOff()
            }
          }
      )
    },
    editCutoff(){
      let t = this;
      let cutoff_id =  event.currentTarget.getAttribute('data-id');
      let filterCutoff = t.cutoffList.filter(
          cutoffItem => cutoffItem.college_cut_off_enc_id == cutoff_id
      )
      t.eCutoff = filterCutoff[0];
    },
  }
}
</script>

<style scoped>
#cutOffForm .formTextFields{
  margin-bottom: 0;
}
.card{
  box-shadow: none;
  border: 1px solid #f7f7f9;
}
</style>